export function WOS (url) {
  return window.open(url, '_blank')
}

export function WR (url) {
  return window.location.replace(url)
}

export function open3party (url) {
  return window.open(url, '_blank', 'height=1159,width=719,top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no, location=no,status=no')
}
